import { AlertProps, Alert } from '@tribeplatform/react-ui-kit/Alert'

import { BC } from '../../types/index.js'

export const AlertBlock: BC<AlertProps> = Alert
